// removed by extract-text-webpack-plugin
module.exports = {"header":"R5BB8PMkHzzJz1cs-ZpAy","scale-in":"_32AQQLGdXuglFgPVd-SuIQ","page-content":"_1Fg1Xn62okjU2uUuC_DYE","image":"_1CVU6epqR8aBtT-IGX4ZY","text":"_26COD7CMt4mts9tg_79lP_","intro":"_17X67uwE7KVznn_tQ7qKMs","slide-up":"vflav9QmxwSxI2oYG5VCC","heading":"_1Rycmg0i5th_z3Gsk2nSDF","logo":"_3j57UHkq-xO3UEGI2lN9mt","linksList":"_1jomT66OhvcEyzyFjhVDVj","linksItem":"_3EE7S1MuvQ1fBLrbjVvCJ","curious":"_29ZD1e-Xv8dm-ooZ4VzbHa","hasCurious":"_3uQhPpBL5BwW5faOKuUT-g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderImageBlock/HeaderImageBlock.module.scss
// module id = 775
// module chunks = 0